import { Package } from '../../../../features/account/types/User'

export enum PackageType {
  None = 0,
  Insights = 1,
  MyGames = 2,
  Markets = 3,
}

export enum PackageTier {
  Free = 0,
  Indie = 1,
  Basic = 2,
  Pro = 3,
  Enterprise = 4,
  Tailored = 5,
  Trial = 6,
}

/**
 * A package as the admin API stores it. `Package` is an organization's purchased copy of one, which
 * adds `packageId`, `purchasedAt`, `expiration` and `note`.
 */
export type InternalPackage = Omit<Package, 'roles' | 'description' | 'stripeId' | 'type' | 'tier' | 'expiration' | 'purchasedAt' | 'note' | 'packageId'> & {
  roles: string[] | null
  description: string | null
  stripeId: string | null
  type: PackageType
  tier: PackageTier
}

export type PackageCreate = Pick<
  InternalPackage,
  'name' | 'description' | 'roles' | 'type' | 'tier' | 'price' | 'maxGameSlots' | 'maxFollowedGames' | 'visible'
>

export type InternalRole = {
  id: string
  createdAt: number
  modifiedAt: number
  createdBy: string | null
  modifiedBy: string | null
  name: string
  description: string | null
}

export type RoleCreate = Pick<InternalRole, 'name' | 'description'>

export type FeatureModule = {
  id: string
  createdAt: number
  modifiedAt: number
  createdBy: string | null
  modifiedBy: string | null
  name: string
  description: string | null
  roles: string[]
}

/** Without an `id` the module is created, with one the stored module is replaced. */
export type FeatureModuleSave = Pick<FeatureModule, 'name' | 'description' | 'roles'> & Partial<FeatureModule>

/** What a write left on the backend, read back right after it. `undefined` when the entity isn't there. */
export type StoredAfterWrite<Entity> = { stored?: Entity }
